import { client, getErrorMessage } from "./client";

const baseUrl = "/trainLog";

export const getTrainLog = async (uuid: string) => {
  try {
    const response = await client.get(`${baseUrl}/log/${uuid}`);
    return response.data;
  } catch (error: any) {
    throw new Error(getErrorMessage(error));
  }
};

export const getLatestTrainLog = async (uuid: string) => {
  try {
    const response = await client.get(`${baseUrl}/latest-log/${uuid}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
